var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChamberFullColdWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 202,
    height: 76,
    viewBox: "0 0 202 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Full-Cold_Water",
    "data-name": "Full-Cold Water",
    transform: "translate(0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9816",
    "data-name": "Group 9816",
    transform: "translate(-0.005 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M13.439,75.35a3.016,3.016,0,0,1-3.11-2.9V21.24a1.5,1.5,0,0,0-.51-1.11L1.59,12.61A2.723,2.723,0,0,1,.84,9.56,3.083,3.083,0,0,1,3.76,7.64H198.215a3.059,3.059,0,0,1,2.92,1.92,2.727,2.727,0,0,1-.75,3.05l-8.229,7.52a1.487,1.487,0,0,0-.51,1.11V72.45a3.01,3.01,0,0,1-3.11,2.9Z",
    transform: "translate(0.005 -7)",
    fill: "#f1f1f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9815",
    "data-name": "Group 9815",
    transform: "translate(1.309 1.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    d: "M199.955,12.13l-8.229,7.52a2.151,2.151,0,0,0-.72,1.59V72.45a2.355,2.355,0,0,1-2.46,2.24H13.439a2.355,2.355,0,0,1-2.46-2.24V21.24a2.151,2.151,0,0,0-.72-1.59L2.03,12.13A2.225,2.225,0,0,1,3.76,8.3H198.215A2.224,2.224,0,0,1,199.955,12.13Z",
    transform: "translate(-1.305 -8.3)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    d: "M13.44,75.35H188.557a3.016,3.016,0,0,0,3.11-2.9V21.24a1.479,1.479,0,0,1,.36-.95,8.662,8.662,0,0,0-1.41,1.06s-6.779,5.84-12.7,0-10.959,0-10.959,0-6.43,6.18-12.7,0-11.829,0-11.829,0-5.83,7.59-12.519.98c-6.04-5.96-11.519-1.18-12.539-.17v-.05s-6.27,5.15-11.479,0-10.429,0-10.429,0-6.779,5.84-12.7,0-10.959,0-10.959,0-6.43,6.18-12.7,0-11.829,0-11.829,0-5.83,7.59-12.519.98c-5.92-5.85-11.309-1.35-12.479-.24-1.89,1.19-6.57,3.4-10.629-.6a8.794,8.794,0,0,0-1.35-1.11c0,.03.01.07.01.1V72.45A3.041,3.041,0,0,0,13.44,75.35Z",
    transform: "translate(0.004 -7)",
    fill: "#00b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    d: "M198.225,8.3a2.227,2.227,0,0,1,1.74,3.83l-8.229,7.52a2.151,2.151,0,0,0-.72,1.59V72.45a2.355,2.355,0,0,1-2.46,2.24H13.439a2.355,2.355,0,0,1-2.46-2.24V21.24a2.151,2.151,0,0,0-.72-1.59L2.03,12.13A2.225,2.225,0,0,1,3.76,8.3H198.225m0-1.3H3.76A3.725,3.725,0,0,0,.23,9.33a3.357,3.357,0,0,0,.92,3.76l8.229,7.52a.855.855,0,0,1,.3.62V72.44a3.664,3.664,0,0,0,3.76,3.55H188.556a3.664,3.664,0,0,0,3.76-3.55V21.24a.8.8,0,0,1,.3-.62l8.229-7.52a3.378,3.378,0,0,0,.92-3.76A3.753,3.753,0,0,0,198.225,7Z",
    transform: "translate(0.005 -7)",
    fill: "#808184"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4308",
    "data-name": "Rectangle 4308",
    width: 201.985,
    height: 76,
    transform: "translate(0)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChamberFullColdWater);
export default __webpack_public_path__ + "static/media/chamber_full_cold_water.831ee3c81519e5e20353fdf0974515ac.svg";
export { ForwardRef as ReactComponent };